import React, { useState, useEffect, useCallback } from 'react';
import { X } from 'lucide-react';

const DEFAULT_PRIVACY_POLICY = "By using this chatbot, you agree to our [privacy policy](https://chattrick-app.witniumtech.com/privacy-policy)"

const Sidebar = ({ title, description, children, isOpen, onClose, side = 'right', settings }) => {
    const [isRendered, setIsRendered] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [showPrivacyBanner, setShowPrivacyBanner] = useState(true);

    // Get title and description from settings if available
    const headerTitle = settings?.styling?.title ? settings.styling.title : title;
    const headerDescription = settings?.styling?.description ? settings.styling.description : description;

    useEffect(() => {
        if (isOpen) {
            setIsRendered(true);
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setIsVisible(true);
                });
            });
        }
    }, [isOpen]);

    const handleClose = useCallback((explicitClose = false) => {
        setIsVisible(false);
        setTimeout(() => {
            onClose(explicitClose); // Pass the explicitClose flag to the parent
        }, 300);
    }, [onClose]);

    const handleTransitionEnd = () => {
        if (!isVisible && !isOpen) {
            setIsRendered(false);
        }
    };

    if (!isRendered) return null;


    return (
        <div className="fixed inset-0 z-50 overflow-hidden">
            <div
                className={`absolute inset-0 bg-black transition-opacity duration-300 ease-in-out ${isVisible ? 'opacity-20' : 'opacity-0'}`}
                onClick={handleClose}
            />
            <div className={`absolute inset-y-0 ${side}-0 max-w-full flex h-full`}>
                <div
                    className={`w-screen max-w-md transform transition-transform duration-300 ease-in-out h-full`}
                    style={{
                        position: 'fixed',
                        [side]: 0,
                        transform: isVisible ? 'translateX(0)' : `translateX(${side === 'left' ? '-100%' : '100%'})`,
                    }}
                    onTransitionEnd={handleTransitionEnd}
                >
                    <div className="h-full flex flex-col bg-white shadow-xl">
                        <div className="p-4">
                            <div className="flex items-start justify-between">
                                <div className='flex-1 min-w-0 pr-4'>
                                    <h3 className="text-xl font-semibold text-slate-700 truncate">{headerTitle}</h3>
                                    <p className='text-slate-700 truncate'>{headerDescription}</p>
                                </div>
                                <button
                                    onClick={handleClose}
                                    className="flex-shrink-0 text-slate-500 hover:text-slate-700 transition-colors duration-200"
                                >
                                    <X size={24} />
                                </button>
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto p-4 pt-0">
                            
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;